module.exports = __webpack_public_path__ + "static/media/login-bc.4f68633f.png";